import React from 'react';
import BodyItem from './BodyItem';
import text from '../../text';
import SocialMedia, { BRANDS } from '../socialMedia';
var SocialMediaSection = function() {
    return /*#__PURE__*/ React.createElement(BodyItem, {
        className: "SocialMediaSection",
        title: text('follow')
    }, /*#__PURE__*/ React.createElement(SocialMedia, {
        brand: BRANDS.INSTAGRAM
    }), /*#__PURE__*/ React.createElement(SocialMedia, {
        brand: BRANDS.LINKEDIN
    }), /*#__PURE__*/ React.createElement(SocialMedia, {
        brand: BRANDS.YOUTUBE
    }), /*#__PURE__*/ React.createElement(SocialMedia, {
        brand: BRANDS.FACEBOOK
    }), /*#__PURE__*/ React.createElement(SocialMedia, {
        brand: BRANDS.TWITTER
    }));
};
export default SocialMediaSection;
